module.exports = __webpack_public_path__ + "static/media/rug.ef15f149.png";